import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TableViewer from './TableViewer';
import AddData from './AddData';
import ExcelJS from 'exceljs';

import { ReactComponent as ExportIcon } from '../icons/home/export.svg';

import { API_BASE_URL, ItemList, renderModal, closeModal, renderConfirmationModal, handleDelete, handleDuplicate, fetchData, LoadingOverlay, evaluateData} from './Common';


function Project() {
  const { projectId } = useParams();
  const [tables, setTables] = useState([]);
  const [tableColumnData, setTableColumnData] = useState([]);
  const [isTableColumnDataLoaded, setIsTableColumnDataLoaded] = useState(false);
  const [isTablesLoaded, setIsTablesLoaded] = useState(false);

  //const [isDuplicating, setIsDuplicating] = useState(false);
  const [exportModalVisible, setExportModalVisible] = useState(false);
   const [exportModalVisibleAll, setExportModalVisibleAll] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState('JSON');
  const [selectedTableId, setSelectedTableId] = useState(null);

  const [spinnerMessage, setSpinnerMessage] = useState(null);

  const [addData, setAddData] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [tableToDelete, setTableToDelete] = useState(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const [isDuplicating, setIsDuplicating] = useState(false);

  const [modalIconId, setModalIconId] = useState(0);

  const [currentPage, setCurrentPage] = useState(1); // Track current page number
  const itemsPerPage = 10; // Maximum items per page

  const [projectName, setProjectName] = useState('');
  const [isProjectNameLoaded, setIsProjectNameLoaded] = useState(false);

  useEffect(() => {

    fetchData(`${API_BASE_URL}/project/${projectId}`, setProjectName, setIsProjectNameLoaded, 'name');

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables');

    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

  }, [projectId]); // Include projectId in the dependency array to refetch tables when projectId changes


  const handleSaveTable = async (tableId) => {

    setModalMessage("Dados guardados!");
    setModalMessageColor('#43BBC9');
    setModalIconId(3);
    setIsModalOpen(true);


  };

  const handleExportTable = async (tableId) => {
    setSelectedTableId(tableId);
    setExportModalVisible(true);
  };

  const handleExportAll = async (tableId) => {
    setExportModalVisibleAll(true);
  };

const handleDownload = async (all) => {

  const fileName = all ? `tabelas.${selectedFormat.toLowerCase()}` : `${tables[selectedTableId].table_name}.${selectedFormat.toLowerCase()}`;
  const fileData = all ? tables : { [selectedTableId]: tables[selectedTableId] };

  await downloadFile(fileData, fileName);
};

const sanitizeName = (name) => {
  // Replace any characters not allowed in worksheet names
  return name.replace(/[\\/*?:]/g, '_').substring(0, 31); // Limit to 31 characters
};

async function downloadFile(content, fileName) {
    let blob;

    if (selectedFormat === 'CSV') {
      const { columnNames, transposedData } = processTableData(tables[selectedTableId], tableColumnData);
      let formattedData = '';
      formattedData = columnNames.join(';') + '\n'; // Header row

    transposedData.forEach(row => {
      formattedData += row.join(';') + '\n'; // Data rows
    });
      blob = new Blob([formattedData], { type: 'text/plain' });
    }

    else if (selectedFormat === 'JSON') {

      await Promise.all(Object.values(content).map(async selectedTable => {
      const { columnNames, transposedData } = await processTableData(selectedTable, tableColumnData);
    }));


      const jsonContent = JSON.stringify(content, null, 2);
        blob = new Blob([jsonContent], { type: 'text/plain' });
    } else {
      let data = {};
    // Process all tables concurrently
    await Promise.all(Object.values(content).map(async selectedTable => {
      const { columnNames, transposedData } = await processTableData(selectedTable, tableColumnData);

      data[selectedTable.table_name] = { columnNames, transposedData };
    }));


      let workbook = new ExcelJS.Workbook();
      // Iterate through the tables and add them as worksheets to the workbook
      Object.entries(data).forEach(([tableName, { columnNames, transposedData }]) => {
        const worksheetName = sanitizeName(tableName);
        let worksheet = workbook.addWorksheet(worksheetName);
        worksheet.addRow(columnNames);
        worksheet.addRows(transposedData);
      });

      const buffer = await workbook.xlsx.writeBuffer();
      blob = new Blob([buffer], { type: 'application/vnd.oasis.opendocument.spreadsheet' });
    }

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = sanitizeName(fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    //change modals
    setExportModalVisibleAll(false);
    setExportModalVisible(false);

    setModalMessage("Dados Exportados!");
    setModalMessageColor('#233A80');
    setModalIconId(0);
    setIsModalOpen(true);
    //
}

function processTableData(selectedTable, tableColumnData) {
    selectedTable.columns.forEach(column => {
        const { column_id } = column;

        if (tableColumnData[column_id]) {
            column.data = tableColumnData[column_id].data;
        }
    });

    const tableData = selectedTable.columns.map(column => column.data);
    const columnNames = selectedTable.columns.map(column => column.column_name);
    const transposedData = tableData[0].map((_, colIndex) => tableData.map(row => row[colIndex]));

    return { columnNames, transposedData };
}

function ExportModal(visible, handleDownloadFunc, setModalVisibleFunc, showCSVOption) {

  const handleCheckboxChange = (format) => {
    if (selectedFormat !== format) {
      setSelectedFormat(format);
    }
  };

  return (
    visible && (
      <div className="export-modal">
      <ExportIcon/>
      <span className="close" onClick={() => setModalVisibleFunc(false)}>&times;</span>
      <p className="modal-title">Exportar dados</p>
      <p className="modal-intro">Selecionar formato</p>
      <div>
        {showCSVOption && (
          <label>
            <input
              type="checkbox"
              value="CSV"
              checked={selectedFormat === 'CSV'}
              onChange={() => handleCheckboxChange('CSV')}
            />
            <span>CSV</span>
          </label>
        )}
        <label>
          <input
            type="checkbox"
            value="XLSX"
            checked={selectedFormat === 'XLSX'}
            onChange={() => handleCheckboxChange('XLSX')}
          />
          <span>XLSX</span>
        </label>
        <label>
          <input
            type="checkbox"
            value="JSON"
            checked={selectedFormat === 'JSON'}
            onChange={() => handleCheckboxChange('JSON')}
          />
          <span>JSON</span>
        </label>
      </div>
      <button onClick={() => handleDownloadFunc(selectedFormat)}>
      <span>Download</span>
      </button>
    </div>
    )
  );
}


const confirmDeleteTable = async () => {
        setSelectedTableId(null);
setModalIconId(0);
        const token = localStorage.getItem('token');
        await handleDelete('tables', projectId, tableToDelete, token, setTables, tables, setModalMessage, setModalMessageColor, setIsModalOpen, currentPage, setCurrentPage, itemsPerPage);

        setIsConfirmationModalOpen(false);
    };

const handleDeleteClick = (tableId) => {
        setTableToDelete(tableId);
        setIsConfirmationModalOpen(true);
    };

const handleDuplicateTable = async (tableId) => {
  try {
    // Call handleDuplicate and wait for it to finish
    await handleDuplicate(
      'table',
      tableId,
      setTables,
      tables,
      'Tabela Duplicada!',
      setIsDuplicating,
      setModalMessage,
      setModalMessageColor,
      setIsModalOpen
    );

    // Fetch data only after duplication is complete
    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');
  } catch (error) {
    console.error('Error during duplication or data fetching:', error);
  }
};

const hasReadOnlyPermission = Object.values(tables).some(table => table.permission === 'read-only');
//console.log("tableColumnData: " + JSON.stringify(tableColumnData));
//console.log(JSON.stringify(tables, null, 2));
  return (
    <>
    {addData && (
      <AddData
        setTableColumnData={setTableColumnData}
        setTables={setTables}
        projectId={projectId}
      />
    )}
  <div className="home-container">

  {!addData && (<>

    <p className="text0">Gerir dados</p>
    <p>Pré-visualizar tabelas</p>
    <p className="text1">{projectName}</p>

{/************************************************* Tabela com dados*/}
{selectedTableId && (
      <TableViewer
        tableColumnData={evaluateData(tableColumnData)}
        setTableColumnData={setTableColumnData}
        isTablesLoaded={isTablesLoaded}
        setIsTableColumnDataLoaded={setIsTableColumnDataLoaded}
        table={tables[selectedTableId]}
        setIsDuplicating={setIsDuplicating}
        setSpinnerMessage={setSpinnerMessage}

        selectedTableId={selectedTableId}
        tables={tables}
        setTables={setTables}
        projectId={projectId}

        onSave={handleSaveTable}
        onExport={handleExportTable}
        onDelete={handleDeleteClick}
        onDuplicate={handleDuplicateTable}
      />
)}

{/************************************************* Lista de tabelas*/}
{!selectedTableId && (
<ItemList
      tipo="table"
      isLoaded={isTablesLoaded}
      onEdit={setSelectedTableId}
      onDelete={handleDeleteClick}
      onDuplicate={handleDuplicateTable}
      onExport={handleExportTable}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        DataArray={tables}
        itemsPerPage={itemsPerPage}
      />
)}
{/*************************************************/}
</>)}

{/*Confirm delete*/}
{renderConfirmationModal(isConfirmationModalOpen, "Tem a certeza que pretende eliminar os dados?", confirmDeleteTable, () => setIsConfirmationModalOpen(false))}

{/*Delete ou Export sucess*/}
{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

{ExportModal(exportModalVisible, handleDownload, setExportModalVisible, true)}

{ExportModal(exportModalVisibleAll, handleDownload, setExportModalVisibleAll, false)}


<div className="button-container">
<button
  className="button"
  onClick={() => {
    if (!isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId)) {
      return; // Prevent any action if tables are not loaded or if in read-only mode
    }
    if (selectedTableId) {
      setSelectedTableId(null);
    } else {
      setAddData((prevState) => !prevState); // Toggle state to show/hide ChartWidgetCreator
    }
  }}
  style={{
    cursor: !isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId) ? 'not-allowed' : 'pointer',
    opacity: !isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId) ? 0.5 : 1,
  }}
  disabled={!isTablesLoaded || (hasReadOnlyPermission && !addData && !selectedTableId)} // Disable button if tables are not loaded or in read-only mode
>
  <span>
    {(addData || selectedTableId) ? 'Voltar a tabelas' : 'Upload de dados'}
  </span>
</button>



{(!addData && !selectedTableId) && (
<>
<button className="button" onClick={() => handleExportAll()}>
Exportar tudo
</button>
{/*
<button className="button">
  DER
</button>
*/}
</>
)}
</div>

<LoadingOverlay isDuplicating={isDuplicating} spinnerMessage={spinnerMessage}/>

</div>
</>
);

}

export default Project;
